import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#cf3131",
      d: "M50 100a50 50 0 1 0-35.355-14.645A50 50 0 0 0 50 100m17.949-22.949a23.557 23.557 0 0 0-35.9 0 3.129 3.129 0 0 1-4.727-4.1 29.83 29.83 0 0 1 45.352 0 3.129 3.129 0 0 1-4.727 4.1Z"
    }, null, -1)
  ])))
}
export default { render: render }